import { axios } from '@vyce/core/src/api';

import {
  LocationAndTeamsFilterDTO,
  LocationAndTeamsOption,
  RecentlyRegisteredDTO,
  UserDashboards,
} from '../../types';
import config from '../config';

const URL = `${config.gatewayApiUrl}`;

export const getUserDashboardsRequest = (token: string) => {
  return axios.get('/dashboards');
};

export const updateUserDashboardsRequest = (token: string, dashboards: UserDashboards) => {
  return axios.put('/dashboards', dashboards);
};

export const getHealthAndSafetyStatsRequest = ({
  companyId,
  body,
  surveyId,
}: {
  companyId: string;
  body: {
    limit: number;
    team_ids?: string[];
  };
  surveyId: string;
}) => {
  return axios.post(
    `${URL}/public/v1/dashboards/widgets/teams/companies/${companyId}/bar_charts/employees_by_survey_tags_stats/${surveyId}`,
    body
  );
};

export const getTeamsAndLocationsOptionsRequest = (companyId: string) => {
  return axios.get<LocationAndTeamsFilterDTO>(`${URL}/public/v1/dashboards/filters/companies/${companyId}`);
};

export const updateTeamsAndLocationsOptionsRequest = ({
  companyId,
  payload,
}: {
  companyId: string;
  payload: {
    locations: LocationAndTeamsOption[];
    teams: LocationAndTeamsOption[];
  };
}) => {
  return axios.patch(`${URL}/public/v1/dashboards/filters/companies/${companyId}`, payload);
};

export const resetTeamsAndLocationsOptionsRequest = (companyId: string) => {
  return axios.get<LocationAndTeamsFilterDTO>(`${URL}/public/v1/dashboards/filters/companies/${companyId}/reset`);
};

export const getRecentlyRegisteredRequest = ({
  companyId,
  payload,
  moduleType,
  signal,
}: {
  companyId: string;
  payload: {
    offset: number;
    limit: number;
    team_ids?: string[];
  };
  moduleType: 'teams' | 'payroll';
  signal?: AbortSignal;
}) => {
  const modulePath = moduleType === 'teams' ? 'teams' : 'pay';
  return axios.post<{ count: number; items: RecentlyRegisteredDTO[] }>(
    `/dashboards/widgets/${modulePath}/companies/${companyId}/table_charts/recently_registered_${moduleType}_users`,
    payload,
    { signal }
  );
};
